import { CurrencyCode } from '../types/api';

export interface UrlParams {
  clientId: string;
  userId: string;
  userToken: string;
  username: string;
  currency: CurrencyCode;
}

export function getUrlParams(): UrlParams {
  // First try regular query params
  let urlParams = new URLSearchParams(window.location.search);
  
  // If no params found, check if they're in the hash (after #/?)
  if (urlParams.toString() === '') {
    const hash = window.location.hash;
    // Extract params from hash like #/?param=value or #param=value
    const hashSearch = hash.includes('?') ? hash.split('?')[1] : hash.slice(1);
    if (hashSearch) {
      urlParams = new URLSearchParams(hashSearch);
    }
  }
  
  return {
    clientId: urlParams.get('clientId') || '',
    userId: urlParams.get('userId') || '',
    userToken: urlParams.get('userToken') || '',
    username: urlParams.get('username') || '',
    currency: (urlParams.get('currency') as CurrencyCode) || CurrencyCode.DEMO
  };
}

export function validateUrlParams(params: UrlParams): { valid: boolean; error?: string } {
  if (!params.clientId) {
    return { valid: false, error: 'Missing clientId parameter' };
  }
  
  if (!params.userId) {
    return { valid: false, error: 'Missing userId parameter' };
  }
  
  if (!params.userToken) {
    return { valid: false, error: 'Missing userToken parameter' };
  }
  
  if (!params.username) {
    return { valid: false, error: 'Missing username parameter' };
  }
  
  return { valid: true };
}